import script from "./TalentTree.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentTree.vue?vue&type=script&setup=true&lang=js"

import "./TalentTree.vue?vue&type=style&index=0&id=7602ea86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7602ea86"]])

export default __exports__